/** Absolute app paths for marketing email templates (under /campaigns/marketing). */

export const MARKETING_TEMPLATES_PATHS = {
    BASE_LIST: '/campaigns/marketing/templates',
    NEW_SELECTOR: '/campaigns/marketing/templates/new',
    NEW_HTML: '/campaigns/marketing/templates/new/html',
    NEW_VISUAL: '/campaigns/marketing/templates/new/visual',
};

/**
 * Deep-link helpers for editing an existing template (reserved for future routing; editors open via overlay state).
 * @param {number|string} id
 * @returns {string}
 */
export function getMarketingTemplateEditHtmlPath(id) {
    return `${MARKETING_TEMPLATES_PATHS.BASE_LIST}/edit/${encodeURIComponent(String(id))}/html`;
}

/**
 * @param {number|string} id
 * @returns {string}
 */
export function getMarketingTemplateEditVisualPath(id) {
    return `${MARKETING_TEMPLATES_PATHS.BASE_LIST}/edit/${encodeURIComponent(String(id))}/visual`;
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesNewSelectorPath(pathname) {
    const { NEW_SELECTOR } = MARKETING_TEMPLATES_PATHS;
    return pathname === NEW_SELECTOR || pathname === `${NEW_SELECTOR}/`;
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesNewHtmlPath(pathname) {
    const { NEW_HTML } = MARKETING_TEMPLATES_PATHS;
    return pathname === NEW_HTML || pathname === `${NEW_HTML}/`;
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesNewVisualPath(pathname) {
    const { NEW_VISUAL } = MARKETING_TEMPLATES_PATHS;
    return pathname === NEW_VISUAL || pathname === `${NEW_VISUAL}/`;
}

/**
 * List view: /templates only (not /templates/new or editors).
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesListPath(pathname) {
    const { BASE_LIST } = MARKETING_TEMPLATES_PATHS;
    if (!pathname.startsWith(BASE_LIST)) {
        return false;
    }
    if (pathname.startsWith(`${BASE_LIST}/new`)) {
        return false;
    }
    const rest = pathname.slice(BASE_LIST.length);
    return rest === '' || rest === '/';
}

/**
 * Header with search + "Create template" (list menu).
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesListMenuPath(pathname) {
    return isMarketingTemplatesListPath(pathname);
}

/**
 * Header with search only (template picker).
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesSelectorHeaderPath(pathname) {
    return isMarketingTemplatesNewSelectorPath(pathname);
}

/**
 * Full-screen editors: hide list/selector header chrome.
 * @param {string} pathname
 * @returns {boolean}
 */
export function isMarketingTemplatesEditorPath(pathname) {
    return isMarketingTemplatesNewHtmlPath(pathname) || isMarketingTemplatesNewVisualPath(pathname);
}
